import React from "react";
import "./bookDemo/Hero.css";
import "./MainHero.css";
import BookDemoHeroTitle from "./bookDemo/BookDemoHeroTitle";
import HeroImage from "./HeroImage";
import HomeHeroBenefits from "./HomeHeroBenefits";

const MainHeroTitle = () => {
  const scrollToPricing = () => {
    console.log("scrollToPricing function called");
    const pricingSection = document.getElementById("pricing-section");
    if (pricingSection) {
      const rect = pricingSection.getBoundingClientRect();
      const offset = window.pageYOffset + rect.top - 20;
      window.scrollTo({ top: offset, behavior: "smooth" });
    } else {
      console.error("pricing-section element not found");
    }
  };

  return (
    <section className="hero-section">
      <div className="md:pt-24 lg:py-14 mb-[60px]">
        <div className="w-full blur-[160px] rounded-full h-[32vh] md:h-32 absolute bg-cyan-200/10 z-10 top-[30vh] md:top-40" />
        <div className="w-full blur-[200px] rounded-full h-[52vh] md:h-72 absolute bg-indigo-700/30 -z-10 top-[10vh] md:top-32" />
        <div className="mx-auto w-auto lg:w-[1200px] items-center">
          <div className="text-center px-1 lg:px-0 md:text-7xl lg:text-7xl">
            <BookDemoHeroTitle title="Take Your Trading To The " highlight="Next Level" />
            <a className="hero-content mx-auto mb-[10vh] md:mb-[28px] font-medium tracking-wider w-[300px] md:w-[400px] lg:w-[500px] text-slate-100 text-sm md:px-0 md:text-lg inline-block">
              Transform your trading with our fully automated futures trading algos.
            </a>
            <HeroImage />
            <div className="w-full flex justify-center">
              <button type="button" className="hero-btn" style={{ position: "relative", zIndex: 1000 }} onClick={scrollToPricing}>
                <p data-text="Let's go" data-title="Get Started Now">
                  Get Started Now
                </p>
              </button>
            </div>
            <div className="mt-12">
              <HomeHeroBenefits />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default MainHeroTitle;
